import { FC, memo } from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  IconButton,
  SimpleGrid,
  Divider,
  useDisclosure,
  Heading,
  DrawerHeader,
  Box,
} from '@chakra-ui/react'
import { useAuthentication } from 'contexts/Authentication/Provider'
import { DEFAULT_MODULES_IN_THE_API, AVAILABLE_MODULES_IN_THE_API } from 'constants/variables'
import { Research } from 'components/icons/Business'
import { ModuleCard } from 'components'
//import { HasPermissionsToSeeThisComponent } from '@lib/components/validators'
//import { ALL_MODULE_PERMISSIONS } from '@lib/constants/permissions'

type Props = {
  children?: JSX.Element
  placement?: any
}

const ModulesButton: FC<Props> = ({ children, placement = 'right' }) => {
  const { userBond } = useAuthentication()
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      {children ? (
        <Box onClick={onOpen} cursor="pointer">
          {children}
        </Box>
      ) : (
        <IconButton
          aria-label="Botão para navegar entre os modulos"
          variant="ghost"
          colorScheme="gray"
          icon={<Research />}
          onClick={onOpen}
        />
      )}

      <Drawer isOpen={isOpen} placement={placement} onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />

          <DrawerHeader>
            <Heading>Sistemas</Heading>
          </DrawerHeader>
          <DrawerBody>
            <SimpleGrid columns={1} gap={2}>
              {DEFAULT_MODULES_IN_THE_API.map((module) => {
                return <ModuleCard key={module} moduleSlug={module} />
              })}

              {userBond?.is_public_agent && (
                <>
                  <Divider my={1} />

                  <SimpleGrid columns={1} gap={2}>
                    {AVAILABLE_MODULES_IN_THE_API.map((module) => {
                      return <ModuleCard key={module} moduleSlug={module} />
                    })}
                  </SimpleGrid>
                </>
              )}
            </SimpleGrid>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default memo(ModulesButton)
